import { useContext } from 'react'

import { IFilters } from 'src/commons/types'

import { DashboardFiltersContext } from './index'

export const useFilters = (): IFilters => useContext(DashboardFiltersContext)

export function scrollToComponent() {
  const query = new URLSearchParams(window.location.search)
  const componentName = query.get('component')
  const component = componentName && document.getElementById(componentName)
  if (component) {
    component.scrollIntoView()
  }
}
